import styled from "styled-components";

import * as css from "styles/CssVariables.js";

const LoadingBox = styled.div`
  width: 100%;
  margin-top: ${(props) => (props.margintop ? props.margintop : 0)};
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
`;

export default ({ children, marginTop }) => {
  return <LoadingBox margintop={marginTop}>{children}</LoadingBox>;
};
